import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";

const saveDocument = {
    namespaced: true,
    mutations: {
        DATA_SAVE_SUCCESS(state, response) {
            let dataReceive = {
                message: response.result.data.data.textInfo,
                title: response.result.data.message,
                id: response.result.data.data.id,
                path: response.result.data.data.path,
                document: response.document
            }
            eventBus.$emit("saveDocumentSuccess", dataReceive);
        },
        DATA_SAVE_FAILURE(state, error) {
            let dataReceive = {
                title: error.result.response.data.errors.type && error.result.response.data.errors.type[0] === 'diskLimitExceeded' ? error.result.response.data.errors.message[0] : error.result.response.data.message,
                message: error.result.response.data.errors.type && error.result.response.data.errors.type[0] === 'diskLimitExceeded' ? `<ol><li>${error.result.response.data.errors.textInfo[0]}</li></ol>` : handleError(error.result) !== "" ? handleError(error.result) : "",
                document: error.document
            }
            eventBus.$emit("saveDocumentFailure", dataReceive);
        },

    },

    actions: {
        storeDocument: function({ dispatch }, payload) {
            let url = new URL(window.location.href);
            const document = payload.creds.document;
            let formData = new FormData();

            formData.append("file", document.file)
            formData.append("documentableId", url.searchParams.get("id"));
            formData.append("documentableType", document.documentableType);
            formData.append("id", document.id);
            formData.append("fileName", document.fileName);
            formData.append("module", "project");

            let promise = sendRequest("post", config.baseURLApi + "/documents", {}, formData, true, {});
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataSave", { result: result[1], document: payload.creds.document });
                } else {
                    dispatch("failureDataSave", { result: result[1], document: payload.creds.document });
                }
            })
        },
        successDataSave: function({ commit }, creds) {
            commit("DATA_SAVE_SUCCESS", creds);
        },
        failureDataSave: function({ commit }, error) {
            commit("DATA_SAVE_FAILURE", error);
        }
    }
}

export default saveDocument;